// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__rwiZc","buttons":"Footer_buttons__3REam"};